


















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import { ReportDetails } from '@/models/reports/report-details';
import { ReportApi } from '@/api/report-api';
import loading from '@/components/loading.vue';
import { ReportDetailsViewModel } from '@/models/reports/report-details-viewmodel';
import fieldSelector from '@/components/field-selector/field-selector.vue';
import { Field } from '@/models/reports/report-field';
// @ts-ignore
import draggable from 'vuedraggable';
import { FieldSelectorSelection } from '@/models/field-selector/field-selector-selection';

const reportApi = new ReportApi();
const reportModule = namespace('report');
const userModule = namespace('user');
const GROUPBY_AGGREGATE = 6;

@Component({
    components: {
        fieldSelector,
        loading,
        draggable,
    },
})
export default class ReportDisplayColumns extends Vue {
    @Prop({ required: true }) public report: ReportDetailsViewModel;
    @Prop() public selectedColumns: Array<Field>;
    private showDisplayColumnFieldSelector: boolean = false;
    private columnsPerSection: number = 15;
    private targetColumnCount: number = this.columnsPerSection;
    private tempSelectedColumns = this.selectedColumns;
    private tempReport: ReportDetailsViewModel = this.report;
    private selectorOptions: FieldSelectorSelection = new FieldSelectorSelection();

    private get hasColumns(): boolean {
        return this.selectedColumns.length > 0;
    }
    private get visibleColumns(): Array<Field> {
        return this.selectedColumns.slice(0, this.visibleColumnCount);
    }
    private get totalColumnCount(): number {
        return this.selectedColumns.length;
    }
    private get visibleColumnCount(): number {
        return this.targetColumnCount > this.totalColumnCount ? this.totalColumnCount : this.targetColumnCount;
    }
    public get hasMoreColumns() {
        return this.visibleColumnCount < this.totalColumnCount;
    }
    public get hasLessColumns() {
        return this.visibleColumnCount > this.totalColumnCount;
    }

    private showAll(): void {
        const nextStepDistance = this.columnsPerSection + (this.totalColumnCount % this.columnsPerSection);
        const nextStep = this.totalColumnCount + nextStepDistance;

        this.targetColumnCount = nextStep;
    }
    private showMore(): void {
        if (this.targetColumnCount < this.totalColumnCount) {
            this.targetColumnCount = this.targetColumnCount + this.columnsPerSection;
        }
    }
    private showLess(): void {
        if (this.targetColumnCount > this.columnsPerSection) {
            this.targetColumnCount = this.targetColumnCount - this.columnsPerSection;
        }
    }
    private showLeast(): void {
        this.targetColumnCount = this.columnsPerSection;
    }
    private openFieldSelector(): void {
        const results = new FieldSelectorSelection();

        results.SingleSelect = false;

        for (const column of this.selectedColumns) {
            results.Selections.push(column);
        }

        this.selectorOptions = results;
        this.showDisplayColumnFieldSelector = true;
    }
    private selectField(selections: Array<Field>): void {
        this.addDisplayColumns(selections);
        this.showDisplayColumnFieldSelector = false;
    }
    private cancelSelect() {
        this.showDisplayColumnFieldSelector = false;
    }
    private turnOffAggregateColumns() {
        this.$emit('turn-off-aggregate-columns');
    }
    private turnOnAggregateColumns() {
        this.$emit('turn-on-aggregate-columns');
    }
    private addDisplayColumns(columns: Array<Field>): void {
        this.tempSelectedColumns = columns;
        this.$emit('selected-columns-changed', this.tempSelectedColumns);
        this.setSelectedColumnAggregatesToDefault();
        this.refreshTargetColumnCount();
        this.$emit('ensure-query-up-to-date', true);
    }
    private removeDisplayColumn(column: Field): void {
        column.aggregateType = null;

        const index = this.tempSelectedColumns.indexOf(column, 0);

        if (index > -1) {
            this.tempSelectedColumns.splice(index, 1);
        }

        this.$emit('selected-columns-changed', this.tempSelectedColumns);
        this.refreshTargetColumnCount();
        this.$emit('ensure-query-up-to-date', true);
    }
    private removeAllDisplayColumns(): void {
        this.setSelectedColumnAggregatesToDefault();
        this.tempSelectedColumns = [];
        this.$emit('selected-columns-changed', this.tempSelectedColumns);
        this.refreshTargetColumnCount();
        this.$emit('ensure-query-up-to-date', true);
    }
    private refreshTargetColumnCount(): void {
        if (this.targetColumnCount > this.totalColumnCount) {
            this.showAll();
        } else if (this.totalColumnCount < this.columnsPerSection) {
            this.showLeast();
        }
    }
    private setSelectedColumnAggregatesToDefault(): void {
        const defaultAggregateType = this.getDefaultAggregateType;
        for (const selectedColumn of this.tempSelectedColumns) {
            selectedColumn.aggregateType = defaultAggregateType;
        }
    }
    private get getDefaultAggregateType(): number {
        return this.tempReport.includeAggregateColumns ? parseInt(this.report.aggregateColumnTypes[0].value, undefined) : GROUPBY_AGGREGATE;
    }
    @Watch('selectedColumns')
    private selectedColumnsChanged(): void {
        this.tempSelectedColumns = this.selectedColumns;
    }
    private onReordered(): void {
        this.$emit('selected-columns-changed', this.tempSelectedColumns);
    }
    private showFiltersPage(): void {
        this.$emit('show-filters-page');
    }
}
